<homey-notification-dialog-content [title]="title" [closeButton]="closeButton()">
  <div>
    <img src="/assets/gift.png" alt="Gift icon" class="h-32 w-32 mx-auto my-4">
  </div>
  <div class="mb-6">
    <p>Sign up now to let Homey handle all of your Housing Lottery applications.</p>
  </div>
</homey-notification-dialog-content>
<ng-template #title>
  Your friend {{data().name}} has given you <span class="text-orange-gradient">1&nbsp;month&nbsp;free!</span>
</ng-template>

